
import { db } from "app/firebaseInit";
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc } from 'firebase/firestore';

const collectionRef = collection(db, 'loadingMessages');

// Yükleme mesajlarını Firestore'dan al ve cache'e kaydet
export const fetchLoadingMessages = async () => {
    try {
        const snapshot = await getDocs(collectionRef);
        const messages = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        return messages;
    } catch (error) {
        console.error("Error fetching loading messages:", error);
        throw new Error("An error occurred while retrieving loading messages.");
    }
};

// Yeni yükleme mesajı ekle
export const addLoadingMessage = async (title) => {
    try {
        await addDoc(collectionRef, { title });
    } catch (error) {
        console.error("Error adding loading message:", error);
        throw new Error("An error occurred while adding the loading message.");
    }
};

// Yükleme mesajını güncelle
export const updateLoadingMessage = async (id, title) => {
    try {
        const messageRef = doc(db, 'loadingMessages', id);
        await updateDoc(messageRef, { title });
    } catch (error) {
        console.error("Error updating loading message:", error);
        throw new Error("An error occurred while updating the loading message.");
    }
};

// Yükleme mesajını sil
export const deleteLoadingMessage = async (id) => {
    try {
        const messageRef = doc(db, 'loadingMessages', id);
        await deleteDoc(messageRef);
    } catch (error) {
        console.error("Error deleting loading message:", error);
        throw new Error("An error occurred while deleting the loading message.");
    }
};

// Cache'i güncelle
export const updateCacheWithLoadingMessages = (messages) => {
    localStorage.setItem('loadingMessages', JSON.stringify(messages));
};
